import status from '../Status';

export const getSurveyInstructions = async ({ uri }) => {
  try {
    const res = await fetch(uri, {
      method: 'GET',
    });
    const checkd = status.checkStatus(res);
    const json = await checkd.json();
    return json;
  } catch (err) {
    console.log('Survey instruction Error', err);
    throw new Error(err.message);
  }
};
